export default __webpack_public_path__ + "f77f449d4c22d3bb55869bad41b3898f.png";